import { HasId } from '../common';
import { SocketMessageEvent } from '../sockets/messages';

export const notificationWindowMinutes = 60 * 24; // 24 hours

export const displayMaintenanceNotificationSocketEvent = new SocketMessageEvent<{
    notification: MaintenanceNotification;
    message: string;
}>('maintenance.notify');

export interface MaintenanceNotification extends HasId {
    startTime: Date;
    expectedDowntimeInMinutes: number;
}
